// The stage decided in the page's head (lib/edge-to-edge.js), before any
// bundle: a classic script read straight after the viewport meta, so whatever
// is put in the veil as the page is parsed — the picture a crossing carries —
// is already the stage's height, however slow or stalled what follows is.
// It only stages: the class, the three custom properties and the runway's
// scroll. The module does everything else when it comes, and takes a page
// staged here as staged (edge-to-edge.js restage). A page this does not read
// as staged it leaves alone, so a size read too early does no harm: the
// module decides it, as it would have without this.
import { browserFloatsChromeOverThePage, stageMetrics, STAGE_RUNWAY } from './edge-to-edge.js';

if ( browserFloatsChromeOverThePage() ) {
  const html = document.documentElement;
  const metrics = stageMetrics( { screenHeight: window.screen.height, innerHeight: window.innerHeight } );
  for ( const [ name, value ] of Object.entries( metrics ) ) { html.style.setProperty( name, value ); }
  html.classList.add( 'hyper-edge-to-edge' );
  // Once there is a document to scroll; the module's pin holds it after.
  const pin = () => window.scrollTo( { top: STAGE_RUNWAY, behavior: 'instant' } );
  if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', pin, { once: true } );
  } else {
    pin();
  }
}
